module.exports = __webpack_public_path__ + "/login_ui/img/ad-eb626b088084747ac52b2fba85a5b475.svg";